import React, { useContext, useEffect } from 'react'
import { BrowserRouter, Outlet, Route, Routes, useLocation } from 'react-router-dom'
import TicketModal from '../Ticket/TicketModal'
import { RevelationsPage } from "../RightBar/Revelations/RevelationsPage";
import RevelationIframe from "../Revelation/RevelationIframe";
import Deeplink from "../Nav/Deeplink";
import Navbar from "../Nav/NavBar";
import { TicketPage } from "../Ticket/TicketPage";
import { FeedPage } from "../RightBar/ActivityFeed/FeedPage";
import ContactsPage from "../RightBar/Contacts/ContactsPage";
import ChatPageWrapper from '../Chat/ChatPageWarpper';
import LogTicketFromChat from '../Chat/LogTicketFromChat';
import TicketDetailsPage from '../Ticket/TicketDetails/TicketDetailsPage';
import StatusList from '../Ticket/ListControls/StatusList';
import { FieldRenderProps } from '@progress/kendo-react-form';
import LegacyUserInfoPage from '../Revelation/LegacyUserInfoPage';
import TicketNotFound from '../Ticket/TicketDetails/TicketNotFound';
import { Spinny } from '../Nav/Spinny';
import GameplanDetails from '../Gameplan/GameplanDetails';
import LiveTicketView from '../Ticket/TicketDetails/Sections/LiveView';
import Dockbar from '../Ticket/TicketDetails/Sections/Dock/Dockbar';
import { ITicketProps } from '../../types/Ticket/ITicket';
import Homepage from '../Home/Homepage';
import { isMobile } from 'react-device-detect';
import { RevUserContext, RevUserContextType } from '../../context/UserContext';
import TicketConfigTest from '../Ticket/TicketDetails/TicketConfigTest';
import TicketMonitor from '../User/TicketMonitor';

export const AppRoutes = () => {
    const location = useLocation();
    const { backgroundLocation, setBackgroundLocation } = useContext<RevUserContextType>(RevUserContext);
    //const currentPage = location.state as { background?: Location };


    useEffect(() => {
        if (!location.pathname.startsWith('/ticket/new')) {
            setBackgroundLocation(null);
        }
    }, [location.pathname]);


    //Make sure we are not loading this page in an Iframe
    if (window.self !== window.top) {
        window.top.location = window.self.location.href;
        return <Spinny />
    }

    //These are external links that come from emails etc.
    const trustedRevelationRoutes = [
        "/search/default.aspx",
        "/calls/callhistory.aspx",
        "/calls/opencalls.aspx",
        "/contacts/contactinfo.aspx",
        "/reports/loadreport.aspx",
        "/adminUX/DynamicUI/Default.aspx",
        "/kbase/default.aspx",
        "/dashboard/default.aspx",
        "/gameplan/dashboard.aspx",
    ]
    let k = 1;
    return (<>

        <Routes location={backgroundLocation || location}>
            <Route path="/test" element={<StatusList {...{} as FieldRenderProps} />} key={k++} />
            <Route path="/contacts" element={<ContactsPage />} key={k++} />
            <Route path="/feed" element={<FeedPage />} key={k++} />
            <Route path="/revelations" element={<RevelationsPage />} key={k++} />
            <Route element={<Navbar />} key={k++}>
                <Route path="/ticket/:ticketId/config" element={<TicketConfigTest />}></Route>
                <Route path="/" element={isMobile ? <Homepage /> : <RevelationIframe />} key={k++} />
                <Route path="/rev" element={<RevelationIframe />} key={k++} />
                <Route path="/home" element={<Homepage />} key={k++} />
                <Route path="/monitor" element={<TicketMonitor key={k++} />} />
                <Route path="/admin" element={<RevelationIframe url='/adminUX/DynamicUI/Default.aspx?PageName=HelpdeskSetup' />} key={k++} />
                <Route path="/user/:userId" element={<LegacyUserInfoPage />} key={k++} />
                <Route path="/deeplink" element={<Deeplink />} key={k++} />
                <Route path="/ticket/not-found/" element={<TicketNotFound />}></Route>
                <Route path="/ticket/:ticketId/" element={<TicketDetailsPage />}>
                    <Route path="*" />
                </Route>
                {trustedRevelationRoutes.map(t => <Route path={t} key={k++} element={<Deeplink />} />)}
                <Route path="/ticket/edit/:Id/*" element={<TicketPage isModal={false} index={2} key={k++} />}>
                </Route>
                <Route element={isMobile ? <Homepage /> : <RevelationIframe />}>
                    <Route path="/ticket/fromchat/:chatUid" element={<LogTicketFromChat index={9} key={k++} />} />
                    <Route path="/ticket/modal/:Id/*" element={<TicketModal index={18} key={k++} />} />
                    <Route path="/ticket/" element={<TicketModal index={6} />} />
                </Route>
                {/* <Route path="/ticket/:ticketId" element={<TicketDetailsPage key={k++} />} /> */}
                <Route path="/chat" element={<ChatPageWrapper />} key={k++} />
                <Route path="/chat/:id/*" element={<ChatPageWrapper />} key={k++} />
            </Route>
        </Routes>
        <Routes>
            <Route path="/ticket/new">
                <Route path="" element={<><TicketModal index={9} /></>} key={k++} />
                <Route path="*" element={<><TicketModal index={9} /></>} key={k++} />
            </Route>
        </Routes>
        {/* backgroundLocation={JSON.stringify(backgroundLocation)} */}

    </>
    )
}
